// Words and colors for commits and file changes.
import type { FileChangeStatus, GitCommit, GitPerson } from '@modelviewer/core';

export const STATUS_LETTER: Record<FileChangeStatus, string> = { added: 'A', deleted: 'D', modified: 'M', renamed: 'R' };

export const STATUS_COLOR: Record<FileChangeStatus, string> = { added: 'text-added', deleted: 'text-removed', modified: 'text-changed', renamed: 'text-accent' };

export const shortId = (id: string) => id.slice(0, 7);

export function subject(commit: GitCommit): string {
  return commit.message.split('\n', 1)[0]!.trim() || '(no message)';
}

/** The message after its first line. */
export function body(commit: GitCommit): string {
  const nl = commit.message.indexOf('\n');
  return nl < 0 ? '' : commit.message.slice(nl + 1).trim();
}

const relative = new Intl.RelativeTimeFormat(undefined, { numeric: 'auto' });
const STEPS: [Intl.RelativeTimeFormatUnit, number][] = [
  ['second', 60],
  ['minute', 60],
  ['hour', 24],
  ['day', 7],
  ['week', 4.35],
  ['month', 12],
  ['year', Infinity],
];

/** "3 hours ago", "last week". */
export function ago(person: GitPerson, now = Date.now()): string {
  let value = (person.time * 1000 - now) / 1000;
  for (const [unit, size] of STEPS) {
    if (Math.abs(value) < size) return relative.format(Math.round(value), unit);
    value /= size;
  }
  return '';
}

/** The full date and time, in the reader's time zone. */
export function when(person: GitPerson): string {
  return new Date(person.time * 1000).toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' });
}

/** A ref's name without its kind: `main`, `origin/main`, `v1.0`. */
export function refLabel(name: string): string {
  return name.replace(/^refs\/(heads|remotes|tags)\//, '');
}

export function formatSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} bytes`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
}
